module.exports = __webpack_public_path__ + "static/media/excavator.be58e37b.png";